export const errorModalId = 'errorModalId';
